export default "__VITE_PUBLIC_ASSET__f3af83c0__"